// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { reviewRate, reviewDisable, reviewCloseDialog } from '../../actions/review';
import useMergeProps from '../../hooks/useMergeProps';

import Review from './Review';
import selectReviewProps from './Review.selector';

const ReviewContainer = () => {
  const selectedProps = useSelector(selectReviewProps);
  const dispatch = useDispatch();

  const closeDialog = useCallback(() => dispatch(reviewCloseDialog), [dispatch]);
  const rate = useCallback(() => dispatch(reviewRate), [dispatch]);
  const disable = useCallback(() => dispatch(reviewDisable), [dispatch]);
  const actionsProps = useMemo(
    () => ({
      closeDialog,
      rate,
      disable,
    }),
    [closeDialog, disable, rate],
  );

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return <Review {...enhancedProps} />;
};

export default ReviewContainer;
